import { render, staticRenderFns } from "./relCaseEditDialog.vue?vue&type=template&id=c0c21c52"
import script from "./relCaseEditDialog.vue?vue&type=script&lang=js"
export * from "./relCaseEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports